//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { formatDate } from "@/utils/date.js";
import { fetchAuditList, fetchUpdateAudit as fetchAudit } from "@/api/PMS/customerService/lostAndFound/queryList";
export default {
  props: ["keyValue", "showDialog"],
  data: function data() {
    return {
      rules: {},
      goodsIdList: [],
      goodsList: [],
      childData: {}
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs["dataForm"].clearValidate();
      });
      this.getList(); // this.childData = {};
      // this.$set(
      //   this.childData,
      //   "receiveDate",
      //   formatDate(new Date(), "yyyy-MM-dd hh:mm")
      // );
    },
    getList: function getList() {
      var _this2 = this;

      fetchAuditList({
        auditRecordId: this.keyValue
      }).then(function (res) {
        _this2.childData = res.data.data;
      });
    },
    // 同意 OR 不同意
    handApproval: function handApproval(flag) {
      var _this3 = this;

      fetchAudit({
        auditRecordId: this.keyValue,
        auditState: flag,
        auditRemark: this.childData.auditRemark
      }).then(function () {
        _this3.$emit("handCancle", true);

        _this3.$emit("handShow", true);

        _this3.$message({
          message: "确认成功",
          type: "success"
        });
      });
    },
    handCancle: function handCancle() {
      this.$emit("handCancle", false);
    }
  }
};